"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const index_1 = require("./index");
const constants_1 = require("../constants");
const utils_1 = require("../../utils");
const preset = constants_1.OSMOSYS_BUTTON_PRESETS.inline;
exports.OsmosysButtonInline = props => {
    return (react_1.default.createElement(index_1.OsmosysButton, Object.assign({ osysName: "OsmosysButtonInline" }, preset, props, { className: utils_1.classnames(preset.className, props.className) })));
};
//# sourceMappingURL=Inline.js.map